import { observable } from 'mobx';
import { persist } from 'mobx-persist';
import { IMainMenuSettings } from '../../interface/main-menu-settings.interface';
import { IMainMenuItem } from '../../interface/main-menu-item.interface';

export class MainMenuModel implements IMainMenuSettings {
  @persist('list') @observable items: IMainMenuItem[] = [];
  @persist('object') @observable logo: IMainMenuItem = {} as any;
}
